import type {
  Option,
} from '@usealloy/component-library';

export type ServiceData = {
  service_id: number;
  name: string;
};

export type ServicesData = Array<ServiceData>;

export enum ServiceConfigModalMode {
  ALLOY = 'alloy',
  CUSTOMER = 'customer',
  NODE = 'node',
}

export enum CredentialOwner {
  alloy = 'alloy',
  customer = 'customer',
  unknown = 'unknown',
}

export enum DefaultLevel {
  ALLOY = 'alloy',
  CUSTOMER = 'customer',
  NULL = 'null',
}

export interface PossibleValue {
  displayName: string;
  serviceConfigPossibleValueId: number;
}
export interface ServiceConfigOption {
  serviceConfigOptionId: number;
  isRequired: boolean;
  isOwner: boolean;
  isSecret: boolean;
  category: string;
  datatype: string;
  displayName: string;
  description: string;
  possibleValues: PossibleValue[] | null;
  slug: string;
}

export interface FormattedServiceConfigOption {
  id?: number;
  serviceConfigOptionId: number;
  isAdding?: boolean;
  value: string | Option | Option[];
  defaultValue: string | Option | Option[] | null;
  isUsingDefault: boolean;
  defaultLevel: DefaultLevel;
  key?: string;
  publicId?: string;
  defaultCredentialOwner?: CredentialOwner;
}

export interface ServiceConfigForm {
  credentialOwnerOption: Option;
  formattedServiceConfigOptions: FormattedServiceConfigOption[];
}

export interface ParsedOption {
  serviceConfigOptionId: number;
  displayName?: string;
  value: string;
  selectedValues: PossibleValue[];
}
export interface FormattedWorkflowOptions {
  actionId: number;
  applicationName: string;
  applicationToken: string;
  version: number;
  serviceNodeDisplayName: string;
  credentialOwner: CredentialOwner;
  serviceConfigOptions: ParsedOption[];
}

export interface FormattedOptions {
  serviceConfigOptions: ParsedOption[];
}

export interface ServiceConfig {
  serviceId: number;
  selectedWorkflowOptions: FormattedWorkflowOptions[];
  selectedAlloyOptions: {
    serviceConfigOptions: ParsedOption[];
  };
  selectedCustomerOptions: {
    credentialOwner: CredentialOwner;
    serviceConfigOptions: ParsedOption[];
  };
  serviceConfigOptions: ServiceConfigOption[];
}

export interface ServiceConfigsInput {
  credentialOwner: CredentialOwner;
  serviceConfigOptions: {
    is_owner: boolean;
    is_secret: boolean;
    serviceConfigOptionId: number;
    value: string | null;
    possibleValues: number[] | null;
  };
}

export interface ServiceConfigOptionsMapping {
  [serviceConfigOptionId: number]: ServiceConfigOption;
}
